// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MtC_rOWwwVu7Sakz1yfU.WwGzvYxP1z05k5jJMMU7,.MtC_rOWwwVu7Sakz1yfU.uVTQFPpBmSYQtw_0emVI{font-size:12px}.MtC_rOWwwVu7Sakz1yfU.jYIx5XXTs7crsoYtdhha,.MtC_rOWwwVu7Sakz1yfU.uVTQFPpBmSYQtw_0emVI.Lf0qrClmONkGhfBCOTf3{font-size:14px}.P7YdhRwC00cwmw1TagQq.WwGzvYxP1z05k5jJMMU7,.P7YdhRwC00cwmw1TagQq.uVTQFPpBmSYQtw_0emVI{font-size:11px}.P7YdhRwC00cwmw1TagQq.jYIx5XXTs7crsoYtdhha{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageListMajorTextNext": "MtC_rOWwwVu7Sakz1yfU",
	"compact": "WwGzvYxP1z05k5jJMMU7",
	"medium": "uVTQFPpBmSYQtw_0emVI",
	"full": "jYIx5XXTs7crsoYtdhha",
	"firstLineText": "Lf0qrClmONkGhfBCOTf3",
	"messageListMinorTextNext": "P7YdhRwC00cwmw1TagQq"
};
module.exports = ___CSS_LOADER_EXPORT___;
